module.exports = __webpack_public_path__ + "static/img/more-LOGO-02.1312cddb.svg";